export async function getLastTripNumberConfig(axios) {
  try {
    const res = await axios.get("/Travels/LatestTripNumber");
    const fullTripNumber = res.data;

    if (typeof fullTripNumber === 'string' && fullTripNumber.trim() !== "") {
      return { fullTripNumber };
    }

    return null;
  } catch (error) {
    console.error("Error loading trip number:", error);
    throw error;
  }
}

export async function saveTripNumberConfig(axios, config, idCompany) {
  try {
    const payload = {
      ...config,
      idCompany,
    };

    await axios.post("/Travels/SaveOfferTripNumberConfiguration", payload);
    return true;
  } catch (error) {
    console.error("Error saving trip number config:", error);
    throw error;
  }
}

export async function getLastTripNumber(axios) {
  try {
    const res = await axios.get("/Travels/TripNumberGeneration");
    const fullTripNumber = res.data;

    if (typeof fullTripNumber === 'string' && fullTripNumber.trim() !== "") {
      return { fullTripNumber };
    }

    return null;
  } catch (error) {
    console.error("Error loading trip number:", error);
    throw error;
  }
}

export async function getTripNumber(axios) {
  try {
    const res = await axios.get("/Travels/OfferTripNumberConfig");
    const data = res.data || [];
    if (!Array.isArray(data) || data.length === 0) return null;
    const latest = data
      .filter(item => item.createdOn)
      .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())[0];
    return latest || null;
  } catch (error) {
    console.error("Error getting latest trip number:", error);
    throw error;
  }

}